import { t } from "@/i18n-js/instance";
import { baseAxisProps } from "./constants";

interface YScaleConfig {
  clamp: boolean;
  max: "auto" | number;
  min: "auto" | number;
  nice: boolean;
  reverse: boolean;
  stacked: boolean;
  type: "linear";
}

export const buildYScale = (
  hasSecondary: boolean,
  yMaxSecondary: number | null,
  scaleType: "linear" = "linear",
  minOverride?: number,
  maxOverride?: number,
): YScaleConfig => ({
  type: scaleType,
  min: typeof minOverride === "number" ? minOverride : "auto",
  max: hasSecondary
    ? yMaxSecondary || 1
    : typeof maxOverride === "number"
      ? maxOverride
      : "auto",
  stacked: false,
  reverse: false,
  nice: true,
  clamp: true,
});

export const buildRightAxis = (
  hasSecondary: boolean,
  yMax: number | null,
  formatFn: ((v: number) => string) | undefined,
  rootLocale: string[],
) =>
  hasSecondary
    ? {
        ...baseAxisProps,
        tickSize: 0,
        legendOffset: 50,
        legendPosition: "middle" as const,
        legend: t([...rootLocale, "right_axis_label"]),
        tickValues: [0, 20, 40, 60, 80, 100].map(p => ((yMax || 1) * p) / 100),
        format: (value: number) =>
          formatFn
            ? formatFn(Math.round((value / (yMax || 1)) * 100))
            : `${Math.round((value / (yMax || 1)) * 100)}%`,
      }
    : null;
